module.exports = __webpack_public_path__ + "static/img/videoAI_active.01447156.png";